import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from '../../i18n';
import './LanguageSelector.css';

export default function LanguageSelector({ variant = 'dropdown' }) {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('pilotleague_language', langCode);
    setIsOpen(false);
  };

  if (variant === 'inline') {
    return (
      <div className="language-selector-inline">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={`lang-btn ${i18n.language === lang.code ? 'active' : ''}`}
            title={lang.nativeName}
          >
            <span className="lang-flag">{lang.flag}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button 
        className="language-selector-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={t('languageSelector.selectLanguage')}
      >
        <span className="lang-code">{currentLanguage.code.toUpperCase()}</span>
        <svg 
          className={`lang-arrow ${isOpen ? 'open' : ''}`} 
          viewBox="0 0 24 24" 
          width="16" 
          height="16"
        >
          <path d="M7 10l5 5 5-5z" fill="currentColor" />
        </svg>
      </button>

      {isOpen && (
        <div className="language-dropdown">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`language-option ${i18n.language === lang.code ? 'active' : ''}`}
            >
              <span className="lang-name">{lang.nativeName}</span>
              {i18n.language === lang.code && (
                <svg className="lang-check" viewBox="0 0 24 24" width="16" height="16">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
